import MITT_Banner from "@assets/mitt-2026-nominations.jpeg";

export default function MITTBanner() {
  return (
    <div className="border-2 border-gray-2050 my-5">
      <a
        className=""
        href="https://go.gov.sg/mitt2026nominations"
        target="_blank"
        rel="noreferrer"
      >
        <img
          alt=""
          data-entity-type=""
          data-entity-uuid=""
          src={MITT_Banner}
          width="100%"
        />
      </a>
      <div className="justify-center items-center py-2.5 text-center">
        முன்மொழிவு படிவங்களை{" "}
        <a
          href="https://go.gov.sg/mitt2026nominations"
          target="_blank"
          className="underline text-red-100"
          rel="noreferrer"
        >
          இங்கே
        </a>{" "}
        சமர்ப்பிக்கவும்.{" "}
        <a
          href="https://go.gov.sg/mitt2026nominations"
          target="_blank"
          rel="noreferrer"
          className="underline text-red-100"
        >
          https://go.gov.sg/mitt2026nominations
        </a>
      </div>
    </div>
  );
}
